export const debounceFunc = (func: (e: React.ChangeEvent<HTMLInputElement>) => void, timeout = 300): ((e: React.ChangeEvent<HTMLInputElement>) => void) => {
  let timer: NodeJS.Timeout | null
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => { func(e) }, timeout)
  }
}

export const simpleHash = (str: string): number => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash * 31 + char) & 0x7fffffff // Ensures positive 32-bit integer
  }
  return hash
}
